// src/admin/EditProfessionalModal.js

import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { db } from '../config/firebaseConfig';
import { doc, updateDoc } from 'firebase/firestore';

const EditProfessionalModal = ({ show, handleClose, professional, onDataUpdate }) => {
    // ...useState, categories, useEffect, handleChange aynı kalacak...
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);
    const categories = ["Agent", "Authors", "Distributors", "Editors", "Illustrators", "Marketing", "Platforms", "Printers", "Publishers", "Stockists"].sort();

    useEffect(() => {
        if (professional) {
            setFormData(professional);
        }
    }, [professional]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { id, ...dataToUpdate } = formData; // ID'yi güncelleme verisinden ayır
            const professionalRef = doc(db, 'professionals', id);
            await updateDoc(professionalRef, dataToUpdate);
            alert('Entry updated successfully!');
            onDataUpdate();
            handleClose();
        } catch (error) {
            console.error("Error updating document: ", error);
            alert('Failed to update entry.');
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Edit Entry</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    {/* Diğer Form.Group'lar aynı kalacak */}
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" name="name" value={formData.name || ''} onChange={handleChange} />
                    </Form.Group>
                    
                    {/* YENİ: Status Düzenleme Alanı */}
                    <Form.Group className="mb-3">
                        <Form.Label>Status</Form.Label>
                        <Form.Select name="status" value={formData.status || 'pending'} onChange={handleChange}>
                            <option value="pending">Pending</option>
                            <option value="approved">Approved</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Category</Form.Label>
                        <Form.Select name="category" value={formData.category || ''} onChange={handleChange}>
                            {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                        </Form.Select>
                    </Form.Group>
                    
                    {/* Email, Phone, Address grupları aynı kalacak... */}
                     <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" name="email" value={formData.email || ''} onChange={handleChange} />
                    </Form.Group>
                     <Form.Group className="mb-3">
                        <Form.Label>Phone</Form.Label>
                        <Form.Control type="text" name="phone" value={formData.phone || ''} onChange={handleChange} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Address</Form.Label>
                        <Form.Control as="textarea" rows={3} name="address" value={formData.address || ''} onChange={handleChange} />
                    </Form.Group>

                    <Button variant="primary" type="submit" disabled={loading}>
                        {loading ? 'Saving...' : 'Save Changes'}
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditProfessionalModal;